



















































import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from 'vue-property-decorator'
import { ChartCard,ChartCardWings, PieChart, LineChart } from '@/components';
import { CollapseTransition } from "vue2-transitions";

@Component({components: {ChartCard, PieChart, ChartCardWings, LineChart, CollapseTransition}})
export default class GroupCharts extends Vue {
  @Prop() readonly value: any[] | undefined;
  @Prop() readonly total: any | undefined;
  @Prop() readonly groupBy!: string;
  @Prop() readonly optionallyGroupBy!: string;

  private statusColors: any = {
    'failed': '#d9534f', 'transmitted': '#43b4e3', 'delivered': '#5cb85c', 'rejected': '#f8877f', 'not_delivered': '#d2190b',
    'deferred': '#828282', 'expired': '#ea8e17', 'error': '#d9534f', 'processed': '#5cb85c', 'finished': '#5cb85c', 'not_answered': '#d2190b',
    'buffered': '#828282', 'read': '#00a700', 'sent': '#43b4e3'
  }

  get lineChartData(){
    let labels: string[] = [];
    let series: number[] = [];
    let data = {
      labels: labels,
      series: series,
    };
    if (!this.value) return data;
    if (!this.value.length) return data;
    // if (!this.groupBy) return data;

    this.value.sort((a,b) => {
      if (a.date > b.date) {return 1;}
      if (a.date < b.date) {return -1;}
      return 0;
    });

    this.value.forEach(row => {
      data.labels.push(row.date);
      data.series.push(row.total);
    });
    return data;
  }

  get pieChartData() {
    let data: any = [];
    if (!this.value) return data;
    if (!this.value.length) return data;
    if (!this.optionallyGroupBy) return data;
    this.value.forEach((row) => {
      let name = row[this.optionallyGroupBy] ? row[this.optionallyGroupBy] : this.$t("unnamed");
      data.push({
        name: name,
        value: row.total,
      });
    });

    data.sort((a: any, b: any)=>{
      if (a.value > b.value) {return -1;}
      if (a.value < b.value) {return 1;}
      return 0;
    });

    let base: any[] = [];
    let maxLength = 6;
    if (data.length > maxLength) {
      base = data.slice(0,maxLength);
      let other:any[] = data.slice(maxLength-data.length);
      let otherTotal = 0;
      for (let index in other) {
        otherTotal = otherTotal+other[index].value
      }
      base.push({
        name: `Остальные`,
        value: otherTotal,
      });
    } else {
      return data
    }
    return base;
  }

  get totalChartData() {
    let data: any[] = [];
    if (!this.total) return data;
    const $t = this.$t.bind(this);

    for (let index in this.total) {
      if (['date', 'duration', 'charged', 'partner_price', 'total', 'totalRow'].includes(index)) continue;
      if (this.optionallyGroupBy == index) continue
      if (index.endsWith('_parts')) continue;
      let item = this.total[index];
      let color = index in this.statusColors ? this.statusColors[index] : ''

      // if (item) {
        data.push({
          name: $t(index),
          value: item,
          itemStyle: {
            color: color
          }
        })
      // }
    }

    data.sort((a,b)=>{
      if (a.value > b.value) {return -1;}
      if (a.value < b.value) {return 1;}
      return 0;
    });
    // let base:any[] = [];
    // let maxLength = 6;
    // if (data.length > maxLength){
    //   base = data.slice(0,maxLength);
    //   let other:any[] = data.slice(maxLength-data.length);
    //   let otherTotal = 0;
    //   for (let index in other){
    //     otherTotal = otherTotal+other[index].value
    //   }
    //   base.push({
    //     name: `Остальные`,
    //     value: otherTotal,
    //     itemStyle:{
    //       color:'#4c4c4c'
    //     },
    //   });
    // }
    return data;
  }
}
